	<div #mymodalme tabindex="0" [class.modal-hide]="hidden==true" (keyup)="modalClose($event)"  >
    <div class="modal-container" [class.modal-hide]="hidden==true" >
		<div class="modal-content-container">
				<h1 > <i class="icon-warning-sign"></i> {{message}} </h1> <hr/> 
				<button  (click)="close()"> {{buttonMessage}} </button>
		</div>

    </div>
	<div class="modal-background" (click)="close()">&nbsp;</div>
	</div>